<template>
    <div class="main-page-left-aside">
        <div class="aside-first"></div>
        <div class="aside-second"></div>
        <div class="aside-third"></div>
    </div>
</template>

<script>
export default {
    name: "leftAside"
}
</script>

<style scoped>
    .main-page-left-aside > div {
        width: 221px;
    }
    .aside-first {
        height: 328px;
        background-color: #cfa972;
    }
    .aside-second {
        height: 151px;
    }
    .aside-third {
        background-color: #333333;
        height: 178px;
    }
</style>